import React, {useEffect, useState} from 'react';
import { isMobile } from 'react-device-detect';
import { TabsContainer, TabsWrapper, TabItem, TabContent, TabText } from './style';
import { useTranslation } from 'react-i18next';

export const CustomTabs = ({ tabItems, selectedTab, onTabChange }) => {
    const [currentTab, setCurrentTab] = useState(selectedTab || 0);
    const [focusedTab, setFocusedTab] = useState(null);

    const { t } = useTranslation();


    useEffect(() => {
        setCurrentTab(selectedTab);
    }, [selectedTab]);
    
    const handleTabClick = (index) => {
        setCurrentTab(index);
        if (onTabChange) {
            onTabChange(index);
        }
    };

    const handleFocus = (index) => {
        setFocusedTab(index);
    };

    const handleBlur = () => {
        setFocusedTab(null);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleTabClick(index);
        }
    };

    return (
        <TabsContainer>
            <TabsWrapper>
                {tabItems.map((item, index) => (
                    <TabItem
                        key={item.id}
                        tabIndex={currentTab === index ? '-1' : index === 0 ? '1' : '2'}
                        $isSelected={currentTab === index}
                        $isFocused={focusedTab === index}
                        onClick={() => handleTabClick(index)}
                        onFocus={() => handleFocus(index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onBlur={handleBlur}
                    >
                        <TabContent>
                            <TabText>
                                {t(`LABELS.${item[isMobile ? 'dataObjectMobile' : 'dataObject'].toUpperCase()}`)}
                            </TabText>
                        </TabContent>
                    </TabItem>
                ))}
            </TabsWrapper>
        </TabsContainer>
    );
};